<template>
  <div class='condition-curved' v-if="!this.isUSTWall">
    <div class="curved_container">
      <div v-if="searchTabActive === 'CurvedSurface'">
        <!-- 曲面形状(凹面,凸面) -->
        <div class='curved_angle'>
          <div class="span_container">
            <span>{{$t('T_CURVE_SHAPE_TEXT')}}</span>
          </div>
          <div class="select_container">
            <el-select v-model='direction_input' :disabled="disabledFlag">
              <el-option v-for='item in direction' :key='item.value' :label='$t(item.label)' :value='item.value'>
              </el-option>
            </el-select>
          </div>
          <div class="clear"></div>
        </div>

        <div class="img-container">
          <!-- 中心角 弧度 深度 (第1个参数设定) -->
          <div class='curved_select_container_top'>
            <div class="curved_select">
              <el-select v-model="curveSelect" :disabled="disabledFlag">
                <el-option v-for="item in curveSelectOptions" :key='item.value' :label='$t(item.label)'
                  :value='item.value'>
                </el-option>
              </el-select>
            </div>
            <div class="select_span_container ellipsis">
              <!-- 中心角 -->
              <div v-if="curveSelect === '0'">
                <el-input v-model='central_angle_input' class='roomsize_input' :disabled="disabledFlag"
                  @input="testDigital($event, 'central_angle_input')" @blur='changeMutation("central_angle_input", getCurveInputParams(curveSelect2))'
                  @keyup.enter.native="changeMutation('central_angle_input')">
                </el-input>
                <span class='m'>{{$t('T_CURVE_DEGREE')}}</span>
              </div>
              <!-- 弧长 -->
              <div v-if="curveSelect === '1'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="arc_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("arc_input", getCurveInputParams(curveSelect2))'></FtInput>
                </div>
                <div v-else>
                  <inputValidateBox prop='arc_input' :rules="rules.number">
                    <el-input v-model='arc_input' class='roomsize_input' :disabled="disabledFlag" @input="testDigital($event, 'arc_input')"
                      @blur='changeMutation("arc_input", getCurveInputParams(curveSelect2))'
                      @keyup.enter.native='changeMutation("arc_input", getCurveInputParams(curveSelect2))'>
                    </el-input>
                    <span class="m">{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 深度 -->
              <div v-if="curveSelect === '2'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="depth_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("depth_input", getCurveInputParams(curveSelect2))' :forceUpdate="depthForceUpdate"></FtInput>
                </div>
                <div v-else>
                  <inputValidateBox prop='depth_input' :rules="rules.number">
                    <el-input v-model='depth_input' class='roomsize_input' :disabled="disabledFlag" @input="testDigital($event, 'depth_input')"
                      @blur='changeMutation("depth_input", getCurveInputParams(curveSelect2))'
                      @keyup.enter.native='changeMutation("depth_input", getCurveInputParams(curveSelect2))'>
                    </el-input>
                    <span class="m">{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 半径 -->
              <div v-if="curveSelect === '3'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="radius_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("radius_input", getCurveInputParams(curveSelect2))' :forceUpdate="radiusForceUpdate"></FtInput>
                </div>
                <div class="input_unit_container" v-else>
                  <inputValidateBox prop='radius_input' :rules="rules.number">
                    <el-input v-model='radius_input' @input="testDigital($event, 'radius_input')" class='roomsize_input' :disabled="disabledFlag"
                      @blur='changeMutation("radius_input", getCurveInputParams(curveSelect2))'
                      @keyup.enter.native='changeMutation("radius_input", getCurveInputParams(curveSelect2))'>
                    </el-input>
                    <span class='m'>{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 幅(弦长) -->
              <div v-if="curveSelect === '4'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="chord_length_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("chord_length_input", getCurveInputParams(curveSelect2))' :forceUpdate="chordLengthForceUpdate"></FtInput>
                </div>
                <div class="input_unit_container" v-else>
                  <inputValidateBox prop='chord_length_input' :rules="rules.number">
                    <el-input v-model='chord_length_input' @input="testDigital($event, 'chord_length_input')" class='roomsize_input' :disabled="disabledFlag"
                      @blur='changeMutation("chord_length_input", getCurveInputParams(curveSelect2))'
                      @keyup.enter.native='changeMutation("chord_length_input", getCurveInputParams(curveSelect2))'>
                    </el-input>
                    <span class='m'>{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
            </div>
          </div>
          <CurveConditionImage class="curve_condition"
           :curveShape="curveShape"
           :curveDirection="curveDirection"
           :curveSelect="curveSelect"
           :curveSelect2="curveSelect2">
          </CurveConditionImage>
          <!-- 中心角 弧度 深度 (第2个参数设定) -->
          <div class='curved_select_container'>
            <div class="curved_select">
              <el-select v-model="curveSelect2" :disabled="disabledFlag">
                <el-option v-for="item in curveSelectOptions2" :key='item.value' :label='$t(item.label)'
                  :value='item.value'>
                </el-option>
              </el-select>
            </div>
            <div class="select_span_container ellipsis">
              <!-- 中心角 -->
              <div v-if="curveSelect2 === '0'">
                <el-input v-model='central_angle_input' class='roomsize_input' :disabled="disabledFlag"
                  @input="testDigital($event, 'central_angle_input')" @blur='changeMutation("central_angle_input", getCurveInputParams(curveSelect))'
                  @keyup.enter.native="changeMutation('central_angle_input', getCurveInputParams(curveSelect))">
                </el-input>
                <span class='m'>{{$t('T_CURVE_DEGREE')}}</span>
              </div>
              <!-- 弧长 -->
              <div v-if="curveSelect2 === '1'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="arc_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("arc_input", getCurveInputParams(curveSelect))'></FtInput>
                </div>
                <div v-else>
                  <inputValidateBox prop='arc_input' :rules="rules.number">
                    <el-input v-model='arc_input' class='roomsize_input' :disabled="disabledFlag" @input="testDigital($event, 'arc_input')"
                      @blur='changeMutation("arc_input", getCurveInputParams(curveSelect))'
                      @keyup.enter.native='changeMutation("arc_input", getCurveInputParams(curveSelect))'>
                    </el-input>
                    <span class="m">{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 深度 -->
              <div v-if="curveSelect2 === '2'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="depth_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("depth_input", getCurveInputParams(curveSelect))' :forceUpdate="depthForceUpdate"></FtInput>
                </div>
                <div v-else>
                  <inputValidateBox prop='depth_input' :rules="rules.number">
                    <el-input v-model='depth_input' class='roomsize_input' :disabled="disabledFlag" @input="testDigital($event, 'depth_input')"
                      @blur='changeMutation("depth_input", getCurveInputParams(curveSelect))'
                      @keyup.enter.native='changeMutation("depth_input", getCurveInputParams(curveSelect))'>
                    </el-input>
                    <span class="m">{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 半径 -->
              <div v-if="curveSelect2 === '3'">
                <!-- <div class="span_unit_container">
                  <span>{{$t('T_CURVE_RADIUS')}}</span>
                </div> -->
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="radius_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("radius_input", getCurveInputParams(curveSelect))' :forceUpdate="radiusForceUpdate"></FtInput>
                </div>
                <div class="input_unit_container" v-else>
                  <inputValidateBox prop='radius_input' :rules="rules.number">
                    <el-input v-model='radius_input' @input="testDigital($event, 'radius_input')" class='roomsize_input' :disabled="disabledFlag"
                      @blur='changeMutation("radius_input", getCurveInputParams(curveSelect))'
                      @keyup.enter.native='changeMutation("radius_input", getCurveInputParams(curveSelect))'>
                    </el-input>
                    <span class='m'>{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 幅(弦长) -->
              <div v-if="curveSelect2 === '4'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="chord_length_input" :disabledFlag="disabledFlag" :unitData="unit" @blur='changeMutation("chord_length_input", getCurveInputParams(curveSelect))' :forceUpdate="chordLengthForceUpdate"></FtInput>
                </div>
                <div class="input_unit_container" v-else>
                  <inputValidateBox prop='chord_length_input' :rules="rules.number">
                    <el-input v-model='chord_length_input' @input="testDigital($event, 'chord_length_input')" class='roomsize_input' :disabled="disabledFlag"
                      @blur='changeMutation("chord_length_input", getCurveInputParams(curveSelect))'
                      @keyup.enter.native='changeMutation("chord_length_input", getCurveInputParams(curveSelect))'>
                    </el-input>
                    <span class='m'>{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- </el-collapse-item>
    </el-collapse> -->
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import inputValidateBox from '@/components/inputValidateBox'
import FtInput from '@/components/ftInput'
import CurveConditionImage from '@/components/curveConditionImage'

export default {
  components: {inputValidateBox, FtInput, CurveConditionImage},
  name: 'curveCondition',
  props: ['angleActive', 'ambientActive', 'disabledFlag'],
  data () {
    return {
      curve_activeNames: ['1'],
      direction: [
        {
          value: '0',
          label: 'T_CONCAVE'
        },
        {
          value: '1',
          label: 'T_CONVEX'
        }
      ],
      curveSelectOptions: [
        {
          value: '0',
          label: 'T_CURVE_ANGLE'
        }, {
          value: '1',
          label: 'T_CURVE_ARC'
        }, {
          value: '2',
          label: 'T_CURVE_DEPTH'
        }, {
          value: '3',
          label: 'T_CURVE_RADIUS'
        }, {
          value: '4',
          label: 'T_WIDTH'
        }
      ],
      curveSelect: '3',
      radius_input: '0',
      central_angle_input: '0.0',
      arc_input: '0',
      depth_input: '0',
      chord_length_input: '0',
      curveSelect2: '4',
      rules: {
        'number': [
          {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'}
        ],
        'numberValid': [
          // {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'},
          {pattern: /^\d+\.\d+$|\\+$|"+$/g, message: 'T_ALERT_DISPLAY_INPUT_ERROR'}
        ]
      },
      radiusForceUpdate: false,
      arcForceUpdate: false,
      depthForceUpdate: false,
      chordLengthForceUpdate: false
    }
  },
  computed: {
    ...mapState([
      'graph',
      // 'houseInfo',
      'isUSTWall',
      // 'isOutOfSpec',
      'curveShape',
      'curveDirection',
      'curveCenter',
      'curveRadius',
      'curveCentralAngle',
      'curveDepth',
      'curveChordLength',
      'indAngleSwitch',
      'searchTabActive'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    unit () {
      return this.graph.unit
    },
    direction_input: {
      get () {
        return this.curveDirection
      },
      set (value) {
        // this.SET_OFFSET(0)
        this.setCurveCenter(value)
        this.SET_CURVEDIRECTION(value)
      }
    },

    central_angle () { // 角度制
      return (180 * this.curveCentralAngle / Math.PI).toFixed(1)
    },
    curveArc () {
      return this.curveRadius * this.curveCentralAngle
    },
    isFraction () {
      return this.unit === 'T_FEET_FRACTION' || this.unit === 'T_INCH_FRACTION'
    },
    curveSelectOptions2 () {
      let options = this.curveSelectOptions.filter(item => item.value !== this.curveSelect)
      this.checkCurveSelect2(options)
      return options
    }
  },
  watch: {
    angleActive (newValue, oldValue) {
      if (newValue.indexOf('1') !== -1) {
        this.curve_activeNames = ['0']
      }
    },
    ambientActive (newValue, oldValue) {
      if (newValue.indexOf('1') !== -1) {
        this.curve_activeNames = ['0']
      }
    },
    unit (newValue, oldValue) {
      this.radius_input = this.$commonJs.changeUnit(this.curveRadius, newValue, false)
      this.depth_input = this.$commonJs.changeUnit(this.curveDepth, newValue, false)
      this.arc_input = this.$commonJs.changeUnit(this.curveArc, newValue, false)
      this.chord_length_input = this.$commonJs.changeUnit(this.curveChordLength, newValue, false)
    },
    // houseInfo: {
    //   handler (newValue, oldValue) {
    //     if (!this.isOutOfSpec && this.curveDepth) {
    //       this.initCurveInfo()
    //     }
    //   },
    //   deep: true
    // },
    central_angle (newValue, oldValue) {
      this.central_angle_input = newValue
    },
    curveRadius (newValue, oldValue) {
      this.radius_input = this.$commonJs.changeUnit(newValue, this.graph.unit, false)
    },
    curveDepth (newValue, oldValue) {
      this.depth_input = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
      this.$emit('updateValue', true)
    },
    curveArc (newValue, oldValue) {
      this.arc_input = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },
    curveChordLength (newValue, oldValue) {
      this.chord_length_input = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
      this.$emit('updateValue')
    }
  },
  methods: {
    ...mapMutations([
      'SET_CURVEDIRECTION',
      'SET_CURVERADIUS',
      'SET_CURVECENTRALANGLE',
      'SET_CURVECENTER',
      'SET_CURVEDEPTH',
      'SET_CURVECHORDLENGTH',
      'SET_GRAPH_ROOMW',
      'SET_GRAPH_ROOMH',
      'SET_GRAPH_ROOMD',
      'PJX', 'PJZ', 'ratioScreenSizeMax'
    ]),
    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || []).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },
    getCurveInputParams (key) {
      let params = {
        '0': 'central_angle_input',
        '1': 'arc_input',
        '2': 'depth_input',
        '3': 'radius_input',
        '4': 'chord_length_input'
      }
      return params[key]
    },
    checkCurveSelect2 (options) {
      let select = options.find(item => item.value === this.curveSelect2)
      if (!select) {
        this.curveSelect2 = options[0].value
      }
    },
    changeMutation (key, selectedKey, callBack, args = '') {
      this.radiusForceUpdate = false
      this.depthForceUpdate = false
      this.arcForceUpdate = false
      this.chordLengthForceUpdate = false

      this.$nextTick(() => {
        if (!this.isFraction && (isNaN(this[key]) || this[key] === '')) this[key] = '0'
        if (key === 'central_angle_input' && isNaN(this[key])) this[key] = '0.0'
        let tempKey = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
        let tempSelectedKey = this.$commonJs.changeUnit(this[selectedKey], this.graph.unit, true)
        if (!tempKey) {
          this.resetCurveValue(key)
          return
        }
        if (!tempSelectedKey) {
          this[key] = this.$commonJs.changeUnit(tempKey, this.graph.unit, false)
          if (key === 'chord_length_input') {
            this.SET_CURVECHORDLENGTH(tempKey)
          }
          return
        }
        // this[key] = this.$commonJs.changeUnit(data, this.graph.unit, false)
        let radius
        // 1) 半径R と 弦长L
        if ((this.curveSelect === '3' && this.curveSelect2 === '4') || (this.curveSelect === '4' && this.curveSelect2 === '3')) {
          const R = this.$commonJs.changeUnit(this.radius_input, this.graph.unit, true)
          const L = this.$commonJs.changeUnit(this.chord_length_input, this.graph.unit, true)
          radius = R
          let chordLength = L

          // 必要条件: L <= 2R
          if (key === 'radius_input') {
            radius = R < L / 2 ? L / 2 : R
            this.radius_input = this.$commonJs.changeUnit(radius, this.graph.unit, false)
          } else {
            chordLength = this.$commonJs.checkRange(L, 0, 2 * R)
            this.chord_length_input = this.$commonJs.changeUnit(chordLength, this.graph.unit, false)
          }
          if (this.isFraction && radius !== R) {
            this.radiusForceUpdate = true
          }
          if (this.isFraction && chordLength !== L) {
            this.chordLengthForceUpdate = true
          }

          // 半径
          this.SET_CURVERADIUS(radius)
          // 幅(弦长)
          this.SET_CURVECHORDLENGTH(chordLength)

          // 角度θ (弧度制)
          const centralAngle = this.$commonJs.curveRadiusAndChordLengthToCentralAngle(radius, chordLength)
          this.SET_CURVECENTRALANGLE(centralAngle)

          // 深度
          const depth = this.$commonJs.curveRadiusAndThetaToDepth(radius, centralAngle)
          this.SET_CURVEDEPTH(depth)

          // console.log('radius', radius, 'chord_length', chordLength, 'centralAngle', centralAngle, 'depth', depth)
        }
        // 2) 半径R と 深度h
        if ((this.curveSelect === '3' && this.curveSelect2 === '2') || (this.curveSelect === '2' && this.curveSelect2 === '3')) {
          const R = this.$commonJs.changeUnit(this.radius_input, this.graph.unit, true)
          const h = this.$commonJs.changeUnit(this.depth_input, this.graph.unit, true)
          radius = R
          let datah = h

          // 必要条件: h <= R
          if (key === 'radius_input') {
            radius = R < h ? h : R
            this.radius_input = this.$commonJs.changeUnit(radius, this.graph.unit, false)
          } else {
            datah = this.$commonJs.checkRange(h, 0, R)
            this.depth_input = this.$commonJs.changeUnit(datah, this.graph.unit, false)
          }
          if (this.isFraction && radius !== R) {
            this.radiusForceUpdate = true
          }
          if (this.isFraction && datah !== h) {
            this.depthForceUpdate = true
          }

          // 深度
          this.SET_CURVEDEPTH(datah)
          // 半径
          this.SET_CURVERADIUS(radius)
          // 幅(弦长)
          // let val = 8 * R * datah - 4 * datah * datah
          // datah 的最大值是2R, val 不可以能小于0,且L<=2R
          // if (val <= 0) {
          //   this[key] = this.$commonJs.changeUnit(0, this.graph.unit, false)
          //   return
          // }
          // let L = this.$commonJs.changeUnit(Math.sqrt(val), this.graph.unit, true)
          // let dataL = this.$commonJs.checkRange(L, 0, 2 * R)
          const dataL = this.$commonJs.curveRadiusAndDepthToChordLength(radius, datah)
          this.SET_CURVECHORDLENGTH(dataL)

          // 角度θ (弧度制)
          const centralAngle = this.$commonJs.curveRadiusAndChordLengthToCentralAngle(radius, dataL)
          this.SET_CURVECENTRALANGLE(centralAngle)
        }
        // 3) 半径R と 角度θ(deg)
        if ((this.curveSelect === '3' && this.curveSelect2 === '0') || (this.curveSelect === '0' && this.curveSelect2 === '3')) {
          const R = this.$commonJs.changeUnit(this.radius_input, this.graph.unit, true)
          // 角度θ(deg)
          const val = Number(this.central_angle_input) > 180 ? 180 : Number(this.central_angle_input)

          // 角度转换为弧度
          const centralAngle = val * Math.PI / 180
          this.SET_CURVECENTRALANGLE(centralAngle)
          if (key === 'central_angle_input') {
            this.central_angle_input = val.toFixed(1)
          }

          // 半径
          radius = R
          this.SET_CURVERADIUS(radius)

          // 幅(弦长)
          const dataL = this.$commonJs.curveRadiusAndThetaToChordLength(radius, centralAngle)
          this.SET_CURVECHORDLENGTH(dataL)

          // 深度
          const depth = this.$commonJs.curveRadiusAndThetaToDepth(radius, centralAngle)
          this.SET_CURVEDEPTH(depth)
        }
        // 4) 半径R と 弧长s
        if ((this.curveSelect === '3' && this.curveSelect2 === '1') || (this.curveSelect === '1' && this.curveSelect2 === '3')) {
          const R = this.$commonJs.changeUnit(this.radius_input, this.graph.unit, true)
          const s = this.$commonJs.changeUnit(this.arc_input, this.graph.unit, true)
          radius = R
          let arc = s

          // 角度θ(rag)
          const theta = this.$commonJs.curveRadiusAndArcToCentralAngle(radius, arc)
          // 弧度转换为角度
          // 必要条件: 0〜180°
          const val = theta * 180 / Math.PI
          const thetaDeg = val > 180 ? 180 : val
          const centralAngle = thetaDeg * Math.PI / 180
          this.SET_CURVECENTRALANGLE(centralAngle)

          if (key === 'radius_input') {
            radius = this.$commonJs.curveArcAndThetaToRadius(arc, centralAngle)
            this.radius_input = this.$commonJs.changeUnit(radius, this.graph.unit, false)
          } else {
            // 弧长
            arc = this.$commonJs.curveRadiusAndThetaToArc(radius, centralAngle)
            this.arc_input = this.$commonJs.changeUnit(arc, this.graph.unit, false)
          }
          if (this.isFraction && radius !== R) {
            this.radiusForceUpdate = true
          }
          if (this.isFraction && arc !== s) {
            this.arcForceUpdate = true
          }

          // 幅(弦长)
          // 因为0~180°内，所以L<=2R
          const dataL = this.$commonJs.curveRadiusAndThetaToChordLength(radius, centralAngle)
          this.SET_CURVECHORDLENGTH(dataL)

          // 半径
          this.SET_CURVERADIUS(radius)

          // 深度
          const depth = this.$commonJs.curveRadiusAndThetaToDepth(radius, centralAngle)
          this.SET_CURVEDEPTH(depth)
        }
        // 5) 弦长L と 深度h
        if ((this.curveSelect === '4' && this.curveSelect2 === '2') || (this.curveSelect === '2' && this.curveSelect2 === '4')) {
          const L = this.$commonJs.changeUnit(this.chord_length_input, this.graph.unit, true)
          const h = this.$commonJs.changeUnit(this.depth_input, this.graph.unit, true)
          const R = (L * L) / (8.0 * h) + h / 2.0 || 0
          let dataL = L
          let datah = h

          // 必要条件: L <= 2R, h <= R,  h <= L / 2 <=> 2h <= L
          if (key === 'chord_length_input') {
            dataL = this.$commonJs.checkRange(L, 2 * h, 2 * R)
            this.chord_length_input = this.$commonJs.changeUnit(dataL, this.graph.unit, false)
          } else {
            datah = this.$commonJs.checkRange(h, 0, L / 2)
            this.depth_input = this.$commonJs.changeUnit(datah, this.graph.unit, false)
          }
          if (this.isFraction && dataL !== L) {
            this.chordLengthForceUpdate = true
          }
          if (this.isFraction && datah !== h) {
            this.depthForceUpdate = true
          }

          // 弦长L
          this.SET_CURVECHORDLENGTH(dataL)

          // 半径
          radius = (dataL * dataL) / (8.0 * datah) + datah / 2.0 || 0
          this.SET_CURVERADIUS(radius)

          // 角度θ (弧度制)
          const centralAngle = this.$commonJs.curveRadiusAndChordLengthToCentralAngle(radius, dataL)
          this.SET_CURVECENTRALANGLE(centralAngle)

          // 深度
          this.SET_CURVEDEPTH(datah)
          // console.log('L', L, 'dataL', dataL, 'h', h, 'datah', datah, 'R', R, 'radius', radius, 'centralAngle', centralAngle)
        }
        // 6) 弦长L と 角度θ
        if ((this.curveSelect === '4' && this.curveSelect2 === '0') || (this.curveSelect === '0' && this.curveSelect2 === '4')) {
          const L = this.$commonJs.changeUnit(this.chord_length_input, this.graph.unit, true)
          // 角度θ(deg)
          const val = Number(this.central_angle_input) > 180 ? 180 : Number(this.central_angle_input)

          // 角度转换为弧度
          const centralAngle = val * Math.PI / 180
          this.SET_CURVECENTRALANGLE(centralAngle)
          if (key === 'central_angle_input') {
            this.central_angle_input = val.toFixed(1)
          }
          // 弦长L
          this.SET_CURVECHORDLENGTH(L)

          // 半径
          radius = L / (2.0 * (Math.sin(centralAngle / 2.0)))
          this.SET_CURVERADIUS(radius)

          // 深度
          const depth = this.$commonJs.curveRadiusAndThetaToDepth(radius, centralAngle)
          this.SET_CURVEDEPTH(depth)
        }
        // 7) 弦长L と 弧长s
        if ((this.curveSelect === '4' && this.curveSelect2 === '1') || (this.curveSelect === '1' && this.curveSelect2 === '4')) {
          const L = this.$commonJs.changeUnit(this.chord_length_input, this.graph.unit, true)
          const s = this.$commonJs.changeUnit(this.arc_input, this.graph.unit, true)
          let dataL = L
          let datas = s

          // 必要条件: L < s <= (π/2)*L  <=>  2s/π <= L < s
          if (key === 'chord_length_input') {
            dataL = this.$commonJs.checkRange(L, (2 * s) / Math.PI, s - 0.001)
            this.chord_length_input = this.$commonJs.changeUnit(dataL, this.graph.unit, false)
          } else {
            datas = this.$commonJs.checkRange(s, L + 0.1, (Math.PI / 2) * L)
            this.arc_input = this.$commonJs.changeUnit(datas, this.graph.unit, false)
          }
          if (this.isFraction && dataL !== L) {
            this.chordLengthForceUpdate = true
          }
          if (this.isFraction && datas !== s) {
            this.arcForceUpdate = true
          }

          // 弦长L
          this.SET_CURVECHORDLENGTH(dataL)

          // 半径（curveArcToRadius函数内，根据 弦长L 和 弧长s 计算半径）
          radius = this.$commonJs.curveArcToRadius(datas)
          this.SET_CURVERADIUS(radius)

          // 角度θ (弧度制)
          const centralAngle = this.$commonJs.curveRadiusAndChordLengthToCentralAngle(radius, dataL)
          this.SET_CURVECENTRALANGLE(centralAngle)

          // 深度
          const depth = this.$commonJs.curveRadiusAndThetaToDepth(radius, centralAngle)
          this.SET_CURVEDEPTH(depth)
        }
        // 8) 深度h と 角度θ
        if ((this.curveSelect === '2' && this.curveSelect2 === '0') || (this.curveSelect === '0' && this.curveSelect2 === '2')) {
          const h = this.$commonJs.changeUnit(this.depth_input, this.graph.unit, true)
          // 角度θ(deg)
          const val = Number(this.central_angle_input) > 180 ? 180 : Number(this.central_angle_input)

          // 角度转换为弧度
          const centralAngle = val * Math.PI / 180
          this.SET_CURVECENTRALANGLE(centralAngle)
          if (key === 'central_angle_input') {
            this.central_angle_input = val.toFixed(1)
          }

          // 半径
          radius = this.$commonJs.curveDepthAndThetaToRadius(h, centralAngle)
          this.SET_CURVERADIUS(radius)

          // 弦长L
          const L = this.$commonJs.curveRadiusAndThetaToChordLength(radius, centralAngle)
          this.SET_CURVECHORDLENGTH(L)

          // 深度
          this.SET_CURVEDEPTH(h)
        }
        // 9) 深度h と 弧长s
        if ((this.curveSelect === '2' && this.curveSelect2 === '1') || (this.curveSelect === '1' && this.curveSelect2 === '2')) {
          const h = this.$commonJs.changeUnit(this.depth_input, this.graph.unit, true)
          const s = this.$commonJs.changeUnit(this.arc_input, this.graph.unit, true)
          let datah = h
          let datas = s

          // 必要条件: h <= s/π  <=>  s >= π h
          // h >= θ*s/8  <=>  s <= 8h/θ  (假设θ最小值为1e-6用来计算)
          const a = 1e-6
          if (key === 'depth_input') {
            datah = Number(this.$commonJs.checkRange(h, a * s / 8, s / Math.PI).toFixed(1))
            this.depth_input = this.$commonJs.changeUnit(datah, this.graph.unit, false)
          } else {
            datas = Number(this.$commonJs.checkRange(s, Math.PI * h, 8 * h / a).toFixed(1))
            this.arc_input = this.$commonJs.changeUnit(datas, this.graph.unit, false)
          }

          // 角度θ (弧度制)
          let centralAngle = this.$commonJs.curveDepthAndArcToCentralAngle(datah, datas)
          // h と s の組み合わせが解を持ちません(例如h很大，s很小，θ无解)
          if (!centralAngle) {
            centralAngle = Math.PI
            if (key === 'depth_input') {
              datah = (datas / centralAngle) * (1.0 - Math.cos(centralAngle / 2.0))
              this.depth_input = this.$commonJs.changeUnit(datah, this.graph.unit, false)
            } else {
              datas = (datah * centralAngle) / (1.0 - Math.cos(centralAngle / 2.0))
              this.arc_input = this.$commonJs.changeUnit(datas, this.graph.unit, false)
            }
          }

          if (this.isFraction && datah !== h) {
            this.depthForceUpdate = true
          }
          if (this.isFraction && datas !== s) {
            this.arcForceUpdate = true
          }

          this.SET_CURVECENTRALANGLE(centralAngle)

          // 半径
          radius = this.$commonJs.curveArcAndThetaToRadius(datas, centralAngle)
          this.SET_CURVERADIUS(radius)

          // 弦长L
          const L = this.$commonJs.curveRadiusAndThetaToChordLength(radius, centralAngle)
          this.SET_CURVECHORDLENGTH(L)

          // 深度
          this.SET_CURVEDEPTH(datah)
          // console.log('h', h, 'datah', datah, 's', s, 'datas', datas, 'radius', radius, 'L', L, 'centralAngle', centralAngle, 'this.depth_input', this.depth_input)
        }
        // 10) 角度θ と 弧长s
        if ((this.curveSelect === '0' && this.curveSelect2 === '1') || (this.curveSelect === '1' && this.curveSelect2 === '0')) {
          const s = this.$commonJs.changeUnit(this.arc_input, this.graph.unit, true)
          const val = Number(this.central_angle_input) > 180 ? 180 : Number(this.central_angle_input)

          // 角度转换为弧度
          const centralAngle = val * Math.PI / 180
          this.SET_CURVECENTRALANGLE(centralAngle)
          if (key === 'central_angle_input') {
            this.central_angle_input = val.toFixed(1)
          }

          // 半径
          radius = this.$commonJs.curveArcAndThetaToRadius(s, centralAngle)
          this.SET_CURVERADIUS(radius)

          // 弦长L
          const L = this.$commonJs.curveRadiusAndThetaToChordLength(radius, centralAngle)
          this.SET_CURVECHORDLENGTH(L)

          // 深度
          const depth = this.$commonJs.curveRadiusAndThetaToDepth(radius, centralAngle)
          this.SET_CURVEDEPTH(depth)
        }
        this.setCurveCenter(this.curveDirection)
      })
    },
    // setCurveInfo (radius, key) {
    //   if (key !== 'depth_input') {
    //     let depth = this.$commonJs.curveRadiusToDepth(radius)
    //     this.SET_CURVEDEPTH(depth)
    //   }
    //   let centralAngle = this.$commonJs.curveRadiusToCentralAngle(radius)
    //   this.SET_CURVERADIUS(radius)
    //   this.SET_CURVECENTRALANGLE(centralAngle)
    //   this.setCurveCenter(this.curveDirection)
    // },
    initCurveInfo () {
      this.curveSelect = '3'
      this.curveSelect2 = '4'
      this.radius_input = this.$commonJs.changeUnit(this.curveRadius, this.graph.unit, false)
      this.chord_length_input = this.$commonJs.changeUnit(this.curveChordLength, this.graph.unit, false)
      this.changeMutation('radius_input', 'chord_length_input')
      this.central_angle_input = this.central_angle
      this.arc_input = this.$commonJs.changeUnit(this.curveArc, this.graph.unit, false)
      this.depth_input = this.$commonJs.changeUnit(this.curveDepth, this.graph.unit, false)
      this.setCurveCenter(this.curveDirection)
    },
    setCurveCenter (val) {
      let curveCenter
      if (val === '1') { // 凸面
        curveCenter = this.curveDepth - this.curveRadius
      } else {
        curveCenter = this.curveRadius
      }
      this.SET_CURVECENTER(curveCenter)
    },
    onCentralAngleChange (num) {
      if (isNaN(num)) this.central_angle_input = '0.0'
      let value = num * 1
      if (!value) {
        this.resetCurveValue()
        return
      }
      let val = value > 180 ? 180 : value
      let angle = val * Math.PI / 180
      let radius = this.$commonJs.curveCentralAngleToRadius(angle)
      let curveDepth = this.$commonJs.curveRadiusToDepth(radius)
      this.central_angle_input = val.toFixed(1)
      this.SET_CURVEDEPTH(curveDepth)
      this.SET_CURVECENTRALANGLE(angle)
      this.SET_CURVERADIUS(radius)
      this.setCurveCenter(this.curveDirection)
    },
    resetCurveValue (key) {
      this.SET_CURVECENTRALANGLE(0)
      this.SET_CURVERADIUS(0)
      this.SET_CURVEDEPTH(0)
      this.SET_CURVECENTER(null)
      if (key === 'chord_length_input') {
        this.SET_CURVECHORDLENGTH(0)
      }
    },
    getRadiusRange () {
      return { min: this.$commonJs.getChordLength() / 2, max: Number.POSITIVE_INFINITY }
    },
    getArcRange () {
      return { min: this.$commonJs.getChordLength() + 0.1, max: this.getRadiusRange().min * Math.PI }
    },
    getDepthRange () {
      return { min: 0, max: this.$commonJs.getChordLength() / 2 }
    }
  },
  mounted () {
    this.$emit('changeItemActive', this.curve_activeNames)
    this.direction_input = this.curveDirection
    this.initCurveInfo()
  }
}
</script>
<style scoped>
  .select_container {
    float: right;
    width: 140px;
    margin-right: 34px;
  }
  .span_container {
    float: left;
    width: 148px;
  }
  .select_span_container {
    float: left;
  }
  .span_unit_container {
    float: left;
    margin-right: 10px;
  }
  .input_unit_container {
    display: flex;
    float: left;
  }
  .curved_select{
    float: left;
    width: 110px;
    margin-right: 9px;
  }
  .curved_container{
    background: #f0f0f0;
    padding: 10px 0 5px 0;
    font-size: 13px;
  }
  .img-container{
    border: 1px solid #cccccc;
    position: relative;
    background: #ffffff;
    height: 200px;
    margin: 0 10px
  }
  .curved_radius{
    position: absolute;
    top: 1px;
    right: 0;
    background:#f3f3f2;
    z-index: 20
  }
  .curved_radius{
    padding: 3px 10px;
    line-height: 26px;
  }
  .curved_depth,
  .curved_angle {
    padding: 0px 10px 5px;
    line-height: 26px;
  }
  .curved_select_container{
    position: absolute;
    bottom: 0;
    left: 10px;
    line-height: 26px;
    background: #f3f3f2;
    padding: 3px 6px 1px 10px;
  }
  .curved_select_container_top{
    position: absolute;
    left: 10px;
    line-height: 26px;
    background: #f3f3f2;
    padding: 3px 6px 1px 10px;
    z-index: 10;
  }
  .curve_condition{
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/view/condition/curveCondition.vue